import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './common/components/page-not-found/page-not-found.component';
import { LayoutComponent } from './common/layouts/layout-page/layout.component';
import { Full_ROUTES } from './common/routes/full-layout.routes';
import { LayoutMapComponent } from './common/layouts/layout-map/layout-map.component';
import { Map_ROUTES } from './common/routes/map-layout.routes';
const appRoutes: Routes = [
  // {path:'&state', redirectTo: '',pathMatch: 'full'},
  { path: '',component: LayoutComponent, children: Full_ROUTES},
  { path: 'map/:id',component: LayoutMapComponent, children: Map_ROUTES},
  { path: '**', component: PageNotFoundComponent },
];


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(appRoutes, { useHash: true })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
